import { render, staticRenderFns } from "./SkeletonProductRecommendationsSlider.vue?vue&type=template&id=768e51b3&"
import script from "./SkeletonProductRecommendationsSlider.vue?vue&type=script&lang=js&"
export * from "./SkeletonProductRecommendationsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports